/** @format */

import * as React from 'react';
//@ts-ignore
import { View, Animated, StyleSheet } from 'react-native';
//@ts-ignore
import { observer } from 'mobx-react';
//@ts-ignore
import {
  JDText,
  JDDevice,
  JDImage,
  JDTouchable,
  JDTouchableWithoutFeedback,
  JDSwiper,
  JDNativeSystem,
} from '@jdreact/jdreact-core-lib';
const { getRpx, getFontSize } = JDDevice;

import Store from '../services/goodsContrastPageStore/store';
import { Platform } from 'react-native';
interface IStoreProps {
  store: {
    golbalSku: string;
    imageOpacity: any;
    imageViewList: string[];
    fadeOutImageView: () => void;
  };
}
interface IProps extends IStoreProps {}
interface IState {
  currentIndex: number;
}
class ImageViewer extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      currentIndex: 1,
    };
  }
  _onChangePage = (pageNumber: number) => {
    this.setState({
      currentIndex: pageNumber + 1,
    });
  };

  _renderPage = (data) => {
    return (
      <JDTouchableWithoutFeedback onPress={this.fadeOutImageView}>
        <View style={styles.bannerItem}>
          <JDImage style={styles.bannerImage} source={{ uri: `${data.imgUrl}` }} />
        </View>
      </JDTouchableWithoutFeedback>
    );
  };
  fadeOutImageView = () => {
    this.props.store.fadeOutImageView();
  };
  render() {
    const { store } = this.props;
    const { currentIndex } = this.state;
    const { imageViewList, imageOpacity } = store;
    const dataLength = imageViewList.length;
    let dataSource = new JDSwiper.DataSource({
      pageHasChanged: (p1, p2) => p1 !== p2,
    });
    dataSource = dataSource.cloneWithPages(
      imageViewList.map((image, index) => {
        return {
          bannerId: index,
          imgUrl: image,
        };
      })
    );
    return (
      <Animated.View
        style={[
          styles.ImageWapper,
          {
            opacity: imageOpacity,
          },
        ]}
      >
        <JDTouchable
          onPress={this.fadeOutImageView}
          style={{ width: '100%', height: '100%', backgroundColor: '#fff', position: 'absolute', top: 0, left: 0 }}
        ></JDTouchable>
        <View style={styles.ImageCurrent}>
          <JDText style={styles.ImageCurrentText}>{currentIndex}</JDText>
          <JDText style={styles.ImageCurrentLength}>/{dataLength}</JDText>
        </View>
        <View style={styles.body}>
          <View style={styles.viewPager}>
            <JDSwiper
              style={styles.viewPager}
              width={JDDevice.width}
              itemWidth={BANNER_WIDTH}
              itemPadding={BANNER_PADDING}
              dataSource={dataSource}
              renderPageIndicator={false}
              renderPage={this._renderPage}
              autoPlay={false}
              onChangePage={this._onChangePage}
            />
          </View>
        </View>
      </Animated.View>
    );
  }
}
function getDefaultProps() {
  const bannerData = [] as any;
  const dataSource = new JDSwiper.DataSource({
    pageHasChanged: (p1, p2) => p1 !== p2,
  });
  return {
    dataSource: dataSource.cloneWithPages(bannerData),
    dataLength: bannerData.length,
  };
}

ImageViewer.defaultProps = getDefaultProps();

const BANNER_HEIGHT = JDDevice.getRpx(752);
const BANNER_PADDING = Math.floor(JDDevice.width * 0.025);
const BANNER_WIDTH = JDDevice.width;

const BANNER_SHADOW_HEIGHT = BANNER_HEIGHT + BANNER_PADDING * 4;

const styles = StyleSheet.create({
  ImageWapper: {
    width: JDDevice.width,
    height: JDDevice.height,
    backgroundColor: '#ffffff',
    flexDirection: 'row',
    alignItems: 'center',
    position: Platform.OS == 'web' ? 'fixed' : 'absolute',
    top: 0,
    left: 0,
    opacity: 0,
    zIndex: Platform.OS === 'web' ? 1001 : 20,
  },
  ImageCurrent: {
    width: JDDevice.width,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end',
    position: 'absolute',
    top: JDNativeSystem.isIPhoneX ? getRpx(200) : getRpx(100),
    left: 0,
  },
  ImageCurrentText: {
    color: '#262626',
    fontSize: getFontSize(40),
  },
  ImageCurrentLength: {
    fontSize: getFontSize(26),
    color: '#262626',
  },
  body: {
    flexDirection: 'row',
    flex: 1,
    height: BANNER_SHADOW_HEIGHT,
    alignItems: 'center',
    justifyContent: 'center',
  },
  viewPager: {
    width: JDDevice.width,
    height: BANNER_SHADOW_HEIGHT,
    overflow: 'hidden',
  },
  bannerItem: {
    width: BANNER_WIDTH,
    height: JDDevice.getRpx(752),
  },
  bannerImage: {
    width: BANNER_WIDTH,
    height: JDDevice.getRpx(750),
  },
});

const ImageViewerOberver = observer(ImageViewer);
const ImageViewerWapper = (props: IProps) => <ImageViewerOberver {...props} store={Store} />;

export default ImageViewerWapper;
